const affordBorrow = [
  {
    name: 'interestRate',
    label: 'Annual Interest Rate',
    config: {
      allowNegative: false,
      decimalScale: 2,
      fixedDecimalScale: true,
      isNumericString: true,
      suffix: ' %',
    },
  },
  {
    name: 'loanTerm',
    label: 'Term of the Loan',
    config: {
      allowNegative: false,
      isNumericString: true,
      suffix: ' years',
    },
  },
  {
    name: 'tax',
    label: 'Annual Real Estate Tax',
    config: {
      allowNegative: false,
      isNumericString: true,
      prefix: '$',
      thousandSeparator: true,
    },
  },
  {
    name: 'insurance',
    label: 'Annual Homeowners Insurance',
    config: {
      allowNegative: false,
      isNumericString: true,
      prefix: '$',
      thousandSeparator: true,
    },
  },
  {
    name: 'income',
    label: 'Gross Annual Income',
    config: {
      allowNegative: false,
      isNumericString: true,
      prefix: '$',
      thousandSeparator: true,
    },
  },
  {
    name: 'debt',
    label: 'Monthly Debt Obligation',
    config: {
      allowNegative: false,
      isNumericString: true,
      prefix: '$',
      thousandSeparator: true,
    },
  },
];

export default affordBorrow;
